<template>
  <div
    v-if="isShowUpgradePopup"
    :key="isShowUpgradePopup"
    class="subscription-upgrade-popup"
  >
    <div class="popup-container">
      <div class="head">
        <p class="main-title">
          {{ popupTitle }}
        </p>
        <vgp-icon-button
          class="close"
          :icon="{ name:'close-1', size: 20 }"
          @onClick="onClose"
        />
      </div>
      <div
        v-if="loader"
        class="loader-body"
      >
        <loader />
      </div>
      <div
        v-else
        class="body"
      >
        <div class="edit-panel">
          <div class="edit-panel__controls">
            <user-count-select
              :label="locales('upgrade_select_label')"
              :class-name="'borderless'"
              :is-annual="isAnnual"
              :is-current-plan="isCurrentPlan"
              :list="usersSelectionList"
              :selected="selectedUsers"
              :is-popup="true"
              :type="upgradeData.mode"
              :plan="upgradeData.newPlan"
              @onChange="changeUserCount"
            />
            <div
              v-if="!upgradeData.isAnnual && (upgradeData.mode === 'change-plan' || upgradeData.mode === 'change-team-size')"
              :class="['toggle-widget', isAnnual ? 'annual' : 'month']"
            >
              <p
                class="toggle-widget__text toggle-widget__text--month"
                @click="toggleAnnual(false)"
              >
                {{ locales('plans_monthly_locale') }}
              </p>
              <div
                class="toggle-rounded"
                @click="toggleAnnual(!isAnnual)"
              >
                <div class="toggle-rounded__target" />
              </div>
              <p
                class="toggle-widget__text toggle-widget__text--annual"
                @click="toggleAnnual(true)"
              >
                {{ locales('plans_annually_locale') }}
              </p>
              <div :class="['toggle-widget__sticky-item', isAnnual && selectedUsers.count === 1 ? 'dnone' : '']">
                <p class="toggle-widget__text light">
                  {{ locales('save_up_locale') }}
                </p>
              </div>
            </div>
          </div>
          <div class="edit-panel__plans">
            <div class="plan-info">
              <div class="plan-info__about">
                <p class="inner-text label">
                  {{ locales('upgrade_popup_current_label') }}
                </p>
                <p class="inner-text name">
                  {{ subscriptionUserCount + ' ' + `${+subscriptionUserCount === 1 ? locales('one_user_locale') : locales('users_locale')}` }} <br><span>{{ currentPlanName }}</span>
                </p>
                <p class="inner-text sum">
                  {{ `$${formattedValues.subscriptionPriceValue} ${subscriptionPeriod ? locales('upgrade_period_annual') : locales('upgrade_period_month')}` }}
                </p>
              </div>
              <div
                v-if="isShowTotalPrice"
                class="plan-info__total"
              >
                <p class="inner-text name">
                  {{ locales('upgrade_balance_key') }}
                </p>
                <p class="inner-text label">
                  <span>{{ `$${formattedValues.unusedBudgetValue}` }}</span> ({{ `${subscriptionStatus.unusedDays} ${locales('days_locale')}` }})
                </p>
              </div>
            </div>
            <div class="arrow-delimiter">
              <div class="arrow" />
            </div>
            <div :class="['plan-info', isCurrentSubscription ? 'is-disable' : '']">
              <div class="plan-info__about">
                <p class="inner-text label">
                  {{ locales('upgrade_popup_updated_label') }}
                </p>
                <p class="inner-text name">
                  {{ selectedUsers.count + ' ' + `${+selectedUsers.count === 1 ? locales('one_user_locale') : locales('users_locale')}` }} <br><span :class="upgradeData.newPlan.name">{{ newPlanNameTitle }}</span>
                </p>
                <p class="inner-text sum">
                  {{
                    `$${formattedValues.newSubcsriptionPriceValue} ${isAnnual ? locales('upgrade_period_annual') : locales('upgrade_period_month')}`
                  }}
                </p>
              </div>
              <div
                v-if="isShowTotalPrice"
                class="plan-info__total"
              >
                <p class="inner-text name">
                  {{ locales('upgrade_pay_extra_key') }}
                </p>
                <p class="inner-text label">
                  {{ `$${formattedValues.finalPriceValue}` }}
                </p>
              </div>
            </div>
          </div>
          <div class="edit-panel__period">
            <p class="inner-text label">
              {{ `${locales('next_payment_locale')}: ${isCurrentSubscription ? currentNextPaymentDay : newPaymentDay}` }}
            </p>
            <p
              class="inner-text small payment-footer-info"
              @click="liveChatClick"
              v-html="locales('next_payment_description_locale') "
            />
          </div>
        </div>
        <div class="form-panel">
          <div class="form">
            <p class="form-title">
              {{ locales('upgrade_form_title') }}
            </p>
            <div class="input-box">
              <div
                class="input-box__label"
              >
                {{ locales('upgrade_form_label_plan') }}
              </div>
              <div
                :class="['input-box__input input-box__plan-name', upgradeData.newPlan.name]"
              >
                {{ newPlanNameTitle }}
              </div>
            </div>
            <div class="input-box">
              <div
                class="input-box__label"
              >
                {{ locales('upgrade_form_label_team') }}
              </div>
              <div
                class="input-box__input"
              >
                {{ `${selectedUsers.count} ${locales('input_value_editors')}` }}
              </div>
            </div>
            <div class="input-box">
              <div
                class="input-box__label"
              >
                {{ locales('upgrade_form_label_period') }}
              </div>
              <div
                class="input-box__input"
              >
                {{ newPaymentPeriod }}
              </div>
            </div>
            <div class="form-total">
              <p class="form-total__text">
                {{ locales('upgrade_tottal_label') }}
              </p>
              <span class="form-total__text">
                {{ `$${formattedValues.finalPriceValue}` }}
              </span>
            </div>
            <div>
              <span class="payment-remark-upgrade-info">
                {{ locales('upgrade_remark_about_payment_and_tax') }}
              </span>
            </div>
            <vgp-button
              type="primary"
              :disabled="isCurrentSubscription || isDisabledApply"
              :label="locales('apply_locale')"
              @onClick="onSubscriptionUpgrade"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import app, { appIds } from '$$app';
import plansModel from '../../../models/plans';
import dateHelper from '../../../helpers/dateFormats';
import svgIconForVue from '../../common/svgIconForVue';
import userCountSelect from '../components/select.vue';
import loader from '../../common/VueComponents/loader/loader.vue';
import infoIcon from '../../../svg/ic_info.svg';
import PaymentController from '../payment';
import { getPricePerUser } from '../helpers';
import vgpIconButton from '$$vueCmp/globalButton/withIcon/iconButton.vue';
import VgpButton from '$$vueCmp/globalButton/vgpButton.vue';
import numbersHelper from '../../../helpers/numbers';
import globalStore from '../../../store/main';

export default {
  name: 'SubscriptionUpgradePopup',
  components: {
    loader,
    userCountSelect,
    vgpIconButton,
    VgpButton,
  },
  data() {
    return {
      loader: true,
      locales: __,
      usersSelectionList: [],
      selectedUsers: null,
      subscriptionStatus: {
        subscriptionPrice: 0,
        unusedBudget: 0,
      },
      newSubcsriptionPrice: 0,
      finalPrice: 0,
      currentNextPaymentDay: '',
      newPaymentDay: '',
      newPaymentPeriod: '',

      isAnnual: false,
      isShowTotalPrice: true,
      isCurrentUserCount: false,
      isCurrentPlan: false,
      isCurrentPeriod: false,
      isDisabledApply: false,
      icons: {
        infoIcon: svgIconForVue(infoIcon, 24, 24),
      },

      formattedValues: {
        finalPriceValue: 0,
        subscriptionPriceValue: 0,
        unusedBudgetValue: 0,
        newSubcsriptionPriceValue: 0,
      },
    };
  },
  computed: {
    subscriptionData() {
      return this.$store.getters['paymentClient/subscriptionData'];
    },
    subscriptionUserCount() {
      return plansModel.getUserCount();
    },
    currentPlanData() {
      return user.paymentPlans.find(item => item.id === plansModel.getPlanId());
    },
    isShowUpgradePopup() {
      return this.$store.getters['paymentClient/isShowUpgradePopup'];
    },
    upgradeData() {
      const defaultData = {
        isAnnual: user.subscription.is_annual,
        mode: '',
        newPlan: this.currentPlanData,
      };

      const upgradeData = this.$store.getters['paymentClient/upgradeData'];

      return {
        ...defaultData,
        ...upgradeData,
      };
    },
    subscriptionPeriod() {
      return plansModel.isAnnual();
    },
    popupTitle() {
      if (this.upgradeData.mode === 'change-plan') {
        return __('upgrade_plan_popup_title');
      }

      return __('change_team_size_title');
    },
    currentSubscription() {
      return this.controller.getCurrentSubscription();
    },
    isCurrentSubscription() {
      return this.isCurrentUserCount
      && this.isCurrentPlan
      && this.isCurrentPeriod
      && (this.upgradeData.mode === 'change-team-size' || this.upgradeData.mode === 'change-plan');
    },
    currentPlanName() {
      const planName = plansModel.getPlanName();
      const planLocale = plansModel.getPlanTitleLocale();

      if (['base', 'pro'].includes(planName)) {
        return __(`${planLocale}_plan_locale`);
      }

      return planName[0].toUpperCase() + planName.slice(1);
    },
    newPlanNameTitle() {
      return this.upgradeData.newPlan.plan_name[0].toUpperCase() + this.upgradeData.newPlan.plan_name.slice(1);
    },
  },
  watch: {
    async selectedUsers(data) {
      if (+data.count !== +this.subscriptionUserCount) {
        this.isCurrentUserCount = false;
      } else {
        this.isCurrentUserCount = true;
      }

      if ((!this.isAnnual && data.count === 1) || (data.count < this.subscriptionUserCount)) {
        return;
      }

      this.checkPlan(this.isAnnual, data.count);
      this.isDisabledApply = true;

      await this.fetchSubscriptionDetails();
      this.calcPrice(data.count);
      this.setDatePeriod();
      this.setFormattedValues();

      this.isDisabledApply = false;
      this.loader = false;
    },
    isShowUpgradePopup(flag) {
      if (flag) {
        this.init();
      }
    },
  },
  created() {
    this.controller = null;
  },
  methods: {
    async init() {
      this.controller = new PaymentController();
      this.isAnnual = this.upgradeData.isAnnual;

      this.getUserCountForUpgrade();
      app.trigger('sideBar:closeProjects');
      userExtAnalytics.log('payment_page_opened', { type: this.upgradeData.isAnnual ? 'annually' : 'monthly', count: this.selectedUsers });

      this.checkPlan(this.upgradeData.isAnnual, this.selectedUsers.count);
      this.prepareUsersSelectionList();
    },
    getUserCountForUpgrade() {
      const currentUsersSelection = this.controller.usersSelection.find(item => item.count >= this.subscriptionUserCount);

      let selected = currentUsersSelection;

      if (this.upgradeData.mode === 'change-team-size') {
        const index = this.controller.usersSelection.indexOf(currentUsersSelection);

        if (this.subscriptionUserCount % 5 === 0 || this.subscriptionUserCount === 1) {
          selected = this.controller.usersSelection[index + 1 === this.controller.usersSelection.length ? index : index + 1];
        } else {
          selected = this.controller.usersSelection.find(item => item.count === currentUsersSelection.count);
        }
      }

      if (this.upgradeData.userCount) {
        selected = this.controller.usersSelection.find(item => item.count >= this.upgradeData.userCount);
      }

      this.selectedUsers = selected;
    },
    checkPlan(isAnnual, count) {
      const period = isAnnual ? 1 : 0;

      this.isCurrentPlan = this.upgradeData.newPlan.id === user.accountPlanData.payment_plans_id;
      this.isCurrentUserCount = count === this.subscriptionUserCount;
      this.isCurrentPeriod = period === plansModel.isAnnual();

      if (this.upgradeData.mode === 'change-team-size' || this.upgradeData.mode === 'change-plan') {
        if (this.isCurrentPlan && this.isCurrentUserCount && this.isCurrentPeriod) {
          this.isShowTotalPrice = false;
        } else {
          this.isShowTotalPrice = true;
        }
      }
    },
    prepareUsersSelectionList() {
      const preparedUsersSelection = this.controller.usersSelection.map(item => {
        const result = { ...item, disabled: false };

        if (!this.isAnnual && item.count === 1) {
          result.disabled = true;
        }

        if (item.count < this.subscriptionUserCount) {
          result.disabled = true;
        }

        if (this.upgradeData.mode === 'change-team-size' && item.count <= this.subscriptionUserCount) {
          result.disabled = true;
        }

        if (this.upgradeData.userCount && item.count < this.upgradeData.userCount) {
          result.disabled = true;
        }

        return result;
      });

      const index = preparedUsersSelection.indexOf(preparedUsersSelection.find(i => i.count === 15));

      preparedUsersSelection.splice(index, 0, { discount_label: __('payment_user_selection_discount_label') });

      this.usersSelectionList = preparedUsersSelection;
    },
    async fetchSubscriptionDetails() {
      const data = await plansModel.getSubscriptionStatus(user.subscription.provider);

      if (!data) return;

      if (plansModel.currencyCodeIsNotUsd()) { // направлять к сейлам, если подписка куплена другой валютой (currency !== 'usd')
        this.onClose();
        // #contactUs remove old version
        // setTimeout(() => app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form'), 100);
        setTimeout(() => globalStore.dispatch('globalPopup/show', {
          type: 'contactUs',
          title: 'upgrade-via-sale-contact-us-form',
          width: 440,
        }), 100);

        return;
      }

      this.subscriptionStatus = { ...data };
    },
    async toggleAnnual(isAnnual) {
      this.isAnnual = isAnnual;

      const selectItems = [...this.controller.usersSelection];
      const singleUserSelection = this.controller.usersSelection.find(item => item.count === 1);

      singleUserSelection.disabled = false;

      if (!isAnnual && this.selectedUsers.count === 1) {
        this.selectedUsers = this.controller.usersSelection.find(item => item.count === 5);
      }

      if (!isAnnual && this.subscriptionUserCount >= 1) {
        singleUserSelection.disabled = true;
        selectItems.splice(0, 1, singleUserSelection);
      } else if (isAnnual && this.subscriptionUserCount > 1) {
        singleUserSelection.disabled = true;
        selectItems.splice(0, 1, singleUserSelection);
      }

      this.usersSelectionList = selectItems;
      this.checkPlan(isAnnual, this.selectedUsers.count);
      this.isDisabledApply = true;

      await this.fetchSubscriptionDetails();
      this.calcPrice(this.selectedUsers.count);
      this.setDatePeriod();
      this.setFormattedValues();

      this.isDisabledApply = false;
    },
    setDatePeriod() {
      // debugger;
      let newPaymentDay;

      const date = new Date();
      const currentDay = dateHelper.formatDateNoTime(date);

      const planDurationDays = this.isAnnual ? 365 : 30;
      const periodName = this.isAnnual ? __('annual_locale') : __('month_locale');

      if (this.subscriptionStatus.unusedBudget < this.newSubcsriptionPrice) {
        date.setDate(date.getDate() + planDurationDays);
        newPaymentDay = dateHelper.formatDateNoTime(date);
      } else {
        const oneDayCost = this.newSubcsriptionPrice / planDurationDays;
        const priceDiff = this.subscriptionStatus.unusedBudget - this.newSubcsriptionPrice;
        const remainderDays = priceDiff / oneDayCost;

        date.setDate(date.getDate() + planDurationDays + remainderDays);
        newPaymentDay = dateHelper.formatDateNoTime(date);
      }

      this.newPaymentDay = newPaymentDay;
      this.newPaymentPeriod = `${periodName} (${__('from_key')} ${currentDay} ${__('to_key')} ${newPaymentDay.trim()})`;
      this.currentNextPaymentDay = dateHelper.formatDateNoTime(user.subscription.date_to);
    },
    calcPrice(userCount) {
      const annualPrice = getPricePerUser(this.upgradeData.newPlan.annual_price_usd_json, userCount);
      const monthPrice = getPricePerUser(this.upgradeData.newPlan.month_price_usd_json, userCount);

      let newSubcsriptionPrice;

      if (this.isAnnual) {
        newSubcsriptionPrice = (annualPrice * userCount) * 12;
      } else {
        newSubcsriptionPrice = monthPrice * userCount;
      }

      let finalPrice = newSubcsriptionPrice - this.subscriptionStatus.unusedBudget;

      this.newSubcsriptionPrice = newSubcsriptionPrice;

      if (isNaN(finalPrice)) {
        finalPrice = 0;

        return;
      }

      this.finalPrice = finalPrice <= 0 ? 0 : finalPrice;
    },
    changeUserCount(data) {
      this.selectedUsers = data;
    },
    onClose() {
      this.$store.commit('paymentClient/showUpgradePopup', { show: false });
      this.loader = true;
    },
    onSubscriptionUpgrade() {
      const nextPlan = {
        user_count: this.selectedUsers.count,
        billing_period: 1,
        is_annual: this.isAnnual,
        planId: this.upgradeData.newPlan.id,
      };

      userExtAnalytics.log('payment_page_apply_clicked', { type: this.isAnnual ? 'annually' : 'monthly', count: this.selectedUsers.count });
      this.$store.dispatch('paymentClient/subscriptionUpgrade', nextPlan);
      this.$store.commit('paymentClient/showUpgradePopup', { show: false });
      this.isDisabledApply = true;
    },
    liveChatClick(e) {
      if (e.target.closest('.contact-us')) {
        app.trigger(appIds.events.ID_APP_EVENT_LIVECHAT_CLICK);
      }
    },
    setFormattedValues() {
      this.formattedValues = {
        finalPriceValue: isNaN(this.finalPrice) ? 0 : numbersHelper.getFormatted(this.finalPrice),
        subscriptionPriceValue: isNaN(this.subscriptionStatus?.subscriptionPrice) ? 0 : numbersHelper.getFormatted(this.subscriptionStatus.subscriptionPrice),
        unusedBudgetValue: isNaN(this.subscriptionStatus?.unusedBudget) ? 0 : numbersHelper.getFormatted(this.subscriptionStatus.unusedBudget),
        newSubcsriptionPriceValue: isNaN(this.newSubcsriptionPrice) ? 0 : numbersHelper.getFormatted(this.newSubcsriptionPrice),
      };
    },
  },
};
</script>

<style scoped src="./upgradePlanPopup.less"></style>
<style lang='less'>
  p {
    margin-bottom: 0;
  }

  .payment-footer-info {
    a {
      color: #757575 !important;
      text-decoration: underline !important;
      cursor: pointer;

      &:hover {
        color: #424242 !important;
      }
    }
  }

  .payment-remark-upgrade-info {
    color: #757575 !important;
    cursor: pointer;
    font-size: 12px;
    font-family: "Lato-Regular", sans-serif;
    text-decoration: none;
    line-height: 18px;
    display: inline-block;
    padding-bottom: 10px;
  }

</style>
